import { LOGIN_SUCCESS, LOGIN_ERROR, SIGN_OUT, SIGN_UP, SIGN_UP_ERROR, RESET_PASSWORD, RESET_PASSWORD_ERROR, NEW_PASSWORD, NEW_PASSWORD_ERROR } from '../../Actions/actionTypes'

const initState = {
   authError: null,
   resetPasswordState: null,
   newPasswordState: null
}

export default function(state = initState, action){

    switch(action.type){

        case LOGIN_SUCCESS:
        console.log(state)
           return {
               ...state,
               authError: null
           }
        case LOGIN_ERROR:
           return {
               ...state,
               authError: 'Login Failed'
           }
        case SIGN_OUT:  
           return state

        case SIGN_UP:
           return {
             ...state,
             authError: null
           }
        case SIGN_UP_ERROR: 
            return {
            ...state,
            authError: 'Sign Up Failed'
        }  
        case RESET_PASSWORD: 
            return {
            ...state,
            resetPasswordState: true,
           
        }  
        case RESET_PASSWORD_ERROR: 
            return {
            ...state,
            resetPasswordState: "error",
           
        }
        case NEW_PASSWORD: 
            return {
            ...state,
            newPasswordState: true,
           
        }  
        case NEW_PASSWORD_ERROR: 
            return {
            ...state,
            newPasswordState: "error",
           
        }    
        default:
            return state     
    }
}